export const useStyles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        fontFamily: 'Roboto Condensed,sans-serif',
        backgroundColor: '#eebf2f',
        color: '#1f3a4e !important',
    },
    paper: {
        marginTop: theme.spacing(10),
      },
    main: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
    },
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
        backgroundColor: '#eebf2f',
        textAlign:'center',
    },
    avatar: {
        marginTop: theme.spacing(8),
        width: 180,
        height: 180,
      },
      submit: {
        margin: theme.spacing(3, 0, 2),
        backgroundColor: '#1f3a4e',
        color: '#fff'
      },
      title: {
        textTransform: 'uppercase',
        color: '#1f3a4e',
        fontSize: 40,
        fontFamily: 'Bebas Neue, cursive !important',
      },
      titleSmall: {
        // textTransform: 'uppercase',
        fontSize: 18,
        color: '#1f3a4e',
      },
      titleMedium: {
        textTransform: 'uppercase',
        fontSize: 16,
        color: '#1f3a4e',
      },
});